import {
  GstrOneDataType,
  GstrOneFilingStatusDataType,
  GstrTwoADataType,
  GstrTwoBDataType,
  OutwardsDataType,
} from "../../commonTypes/gstTypes";
import { GstModuleTypes } from "./gstModuleTypes";

export const initialState: GstModuleTypes = {
  fetching: false,
  error: null,
  success: null,
  statusCode: null,
  message: null,
  totalOutwardsListCount: 0,
  totalInwardsListCount: 0,
  outwardsData: [] as OutwardsDataType[],
  inwardsData: [] as any,
  gstrOneData: {} as GstrOneDataType,
  totalCgstAmount: 0,
  totalIgstAmount: 0,
  totalInvoiceValue: 0,
  totalSgstAmount: 0,
  totalTaxableValue: 0,
  totalItcAmount: 0,
  gstrOneInvoiceList: [],
  gstrThreeBInvoiceList: [],
  getGstrOnehsnWiseList: [],
  gstrThreeBData: {},
  gstrTwoAReturnsData: [] as GstrTwoADataType[],
  gstrTwoBReturnsData: [] as GstrTwoBDataType[],
  gstFilingError: null,
  gstFilingSuccess: null,
  gstFilingStatusCode: null,
  gstFilingMessage: null,
  gstFilingFetching: false,
  gstNumberList: [],
  approvalSuccess: null,
  gstCommentData: [],
  gstCommentSuccess: null,
  gstOtpMessage: null,
  gstOtpVerifyMessage: null,
  gstOtpError: null,
  gstOtpVerifyError: null,
  gstOtpStatusCode: null,
  gstOtpVerifyStatusCode: null,
  gstOtpFetching: false,
  gstOtpVerifyFetching: false,
  gstOtpRequestFetching: false,
  gstOneFilingACKNumber: null,
  numberOfInvoices: 0,
  numberOfEInvoices:0,
  numberOfUploadInvoices: 0,
  fetchFromGstPortal: 0,
  gstOneFilingStatus: {} as GstrOneFilingStatusDataType,
  gstOneFilingStatusSuccess: null,
  gstOneFilingStatusError: null,
  gstOneFilingStatusStatusCode: null,
  gstOneFilingStatusMessage: null,
};
